import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'utcToMoscow' })
export class UtcToMoscowPipe implements PipeTransform {
  transform(date: string) {
    if (date) {
      return moment(date, 'YYYY-MM-DDTHH:mm:ss').add(3, 'hours').format('YYYY-MM-DDTHH:mm:ss');
    }
  }
}